<template>
    <div class="Admin">
        <div class="row" style="margin-top:10px;">
            <div class="col">
                <ActionButton 
                              :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this Church's entire case file, and enrollment in this program.  This is the equivilant of shredding an entire file."
                              endpoint="ChurchEngagement/Church/DeleteChurch"
                              :payload="{Id: ChurchRecordData.Church.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE CHURCH"
                              button-size="md"
                              v-on:success="OnChurchDeleted"/>
            </div>
        </div>
        <!--<div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>-->
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import ActionButton from '../../../Core/ItemEditors/ActionButton.vue';

    export default {
        props: [
            'ChurchRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            OnChurchDeleted() {
                this.$parent.$parent.CloseChurchRecord(this.ChurchRecordData.Church.Id);
            }
        },
        components: {
            ActionButton
        },
        mounted() {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>